import { useState } from "react";
import { Box, Typography } from "@mui/material";
import Logo from "../img/robo_logo_login.png";
import { GoogleLogin } from "@react-oauth/google";
import Swal from "sweetalert2";
import { pingServer, googleAuth } from "../service/API";

export default function Login(props) {
  const [user, setUser] = useState({});
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [errTextPassword, setErrTextPassword] = useState("");

  function awakeServer() {
    pingServer().then((res) => {
      if (res && res.status === 200 && res.data) {
        console.log("Awake status:", res.data);
      } else {
        console.log(`Awake error:`, res);
      }
    });
  }

  const handleSuccess = async (response) => {
    const { credential, clientId } = response;
    const dataForm = {
      credential,
      clientId,
    };

    await googleAuth(dataForm).then((res) => {
      if (res && res.status === 200) {
        if (res.data.success === true && res.data) {
          // Save the updated object back to sessionStorage
          sessionStorage.setItem(
            "authUserData",
            JSON.stringify({
              userID: res.data.user.id,
              name: res.data.user.name,
              email: res.data.user.email,
              roleID: res.data.user.role_id,
              department: res.data.user.department,
              token: res.data.token,
              login: "Y",
            })
          );

          sessionStorage.setItem(
            "authUserRole",
            JSON.stringify({
              role: res.data.role.role_name,
              permission: res.data.role.permission,
            })
          );

          // Awake Cloud Run Server
          awakeServer();

          window.location.pathname = "/home";
        } else if (res.data.success === false) {
          Swal.fire({
            icon: "error",
            title: "User not found",
            text: "Please register user to Cost Estimation system!",
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: res.data.message,
        });
      }
    });
  };

  const handleFailure = (error) => {
    console.error("Login failed:", error);
  };

  const styles = {
    loginBase: {
      background: `linear-gradient(180deg, rgba(54,7,100,1) 0%, rgba(74,6,143,0.5) 100%)`,
    },

    loginBox: {
      background: `linear-gradient(180deg, rgba(119,135,216,1) 0%, rgba(243,243,245,1) 100%)`,
    },
  };

  const imageWidth = 782;
  const imageHeight = 779;

  return (
    <Box sx={{ background: "#1D589D", height: "100vh" }}>
      <Box
        sx={{
          alignItems: "center",
          height: "100vh",
          fontStyle: { color: "white" },
          maxWidth: "1200px",
          margin: "auto",
          display: "flex",
          flexDirection: { lg: "row", md: "row", xs: "column" },
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            width: { lg: "600px", md: "600px", xs: "100%" },
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%", // Ensure the container takes full width
            }}
          >
            <img
              alt="logo"
              src={Logo}
              width="90%"
              style={{ position: "relative" }}
            />
            <Box
              sx={{
                position: "absolute",
                top: "30%",
                left: "65%",
                color: "white", // Adjust color as needed
              }}
            >
              <Typography variant="subtitle1">..Welcome</Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: { lg: "600px", md: "600px", xs: "100%" },
          }}
        >
          <Box
            component="form"
            noValidate
            sx={{
              padding: "50px 30px 20px 30px",
              borderRadius: "25px",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "25vw",
              minWidth: "250px",
              minHeight: "300px",
              maxWidth: "300px",
              background: "white",
            }}
          >
            <Box sx={{ marginBottom: "40px" }}>
              <Typography variant="h6" color="gray">
                Login
              </Typography>
            </Box>
            <GoogleLogin onSuccess={handleSuccess} onError={handleFailure} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
